<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  open: boolean
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'update:open', value: boolean): void
  (e: 'cancel'): void
  (e: 'confirm'): void
}>()

const modalOpen = computed({
  get: () => props.open,
  set: (value: boolean) => emit('update:open', value)
})

const handleCancel = () => {
  emit('cancel')
}

const handleConfirm = () => {
  emit('confirm')
}
</script>

<template>
  <UModal
    v-model:open="modalOpen"
    :ui="{
      overlay: 'bg-[#101012B2] backdrop-blur-[3px]',
      content: 'w-[calc(100%-32px)] md:w-[480px] bg-[#2D2D39] rounded-[16px] ring-[none]'
    }"
    :dismissible="false"
  >
    <template #content>
      <div class="relative w-full h-full font-['Roboto'] py-[24px] px-[24px]">
        <h2 class="text-[24px] text-[#E7E7EC] font-bold leading-[28px] mb-[16px] text-center">
          Confirm Deletion?
        </h2>
        <p class="text-[16px] text-[#E7E7EC] text-center leading-[22px] mb-[24px]">
          This file will be permanently deleted and cannot be recovered. Confirm deletion?
        </p>
        <div class="flex items-center justify-center gap-x-[16px]">
          <button
            class="w-[160px] py-[10px] rounded-[8px] text-[16px] leading-[20px] border border-[#5E5E77] text-[#E7E7EC] hover:bg-[#383847] transition-colors"
            :disabled="loading"
            @click="handleCancel"
          >
            Cancel
          </button>
          <button
            class="w-[160px] py-[10px] rounded-[8px] text-[16px] leading-[20px] bg-[#BF2AFF] text-white hover:bg-[#A620E5] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
            :disabled="loading"
            @click="handleConfirm"
          >
            {{ loading ? 'Deleting...' : 'Confirm' }}
          </button>
        </div>
      </div>
    </template>
  </UModal>
</template>
